import {
  all, call, put, takeLatest,
} from 'redux-saga/effects';
import * as appConstants from 'redux/constants/app.constants';
import * as constants from 'redux/constants/category.constants';
import {
  getAll, getCategoriesHome, getMarcasHome, getCartelHome,
} from 'services/category.services';

export function* categoryGetAll(data = null) {
  try {
    const isReduxAction = data && data.type;
    const categories = !isReduxAction && data ? data : yield call(getAll);
    yield put({ type: constants.CATEGORY_GET_ALL_SUCCEEDED, data : categories });
  } catch (error) {
    yield put({ type: constants.CATEGORY_GET_ALL_FAILED, error });
  }
}

export function* categoryHomeGet(data = null) {
  try {
    const isReduxAction = data && data.type;
    const categoryHome = !isReduxAction && data ? data : yield call(getCategoriesHome);
    yield put({ type: constants.CATEGORY_GET_CATEGORIES_HOME_SUCCEEDED, data : categoryHome });
  } catch (error) {
    yield put({ type: constants.CATEGORY_GET_CATEGORIES_HOME_FAILED, error });
  }
}

export function* marcasHomeGet(data = null) {
  try {
    const isReduxAction = data && data.type;
    const marcasHome = !isReduxAction && data ? data : yield call(getMarcasHome);
    yield put({ type: constants.CATEGORY_GET_MARCAS_HOME_SUCCEEDED, data : marcasHome });
  } catch (error) {
    yield put({ type: constants.CATEGORY_GET_MARCAS_HOME_FAILED, error });
  }
}

export function* cartelHomeGet(data = null) {
  try {
    const isReduxAction = data && data.type;
    const cartelHome = !isReduxAction && data ? data : yield call(getCartelHome);
    yield put({ type: constants.CATEGORY_GET_CARTEL_HOME_SUCCEEDED, data : cartelHome });
  } catch (error) {
    yield put({ type: constants.CATEGORY_GET_CARTEL_HOME_FAILED, error });
  }
}

export function* watchCategories() {
  yield all([
    // takeLatest(appConstants.APP_INITIALIZE_REQUESTED, categoryGetAll),
    // takeLatest(appConstants.APP_INITIALIZE_REQUESTED, categoryHomeGet),
    // takeLatest(appConstants.APP_INITIALIZE_REQUESTED, marcasHomeGet),
    // takeLatest(appConstants.APP_INITIALIZE_REQUESTED, cartelHomeGet),
  ]);
}
